import ReactGA from 'react-ga';
import AppStorage from 'AppStorage';
import { PolicyPayload as POLICY_PAYLOAD, FamilyStructure } from 'Constants';

export const triggerGaPageview = dataObject => {
  let url = window.location.pathname + window.location.search;

  let plan;

  // Get plan from AppStorage and concat as query string
  try {
    const policyPayload = AppStorage.getItem(POLICY_PAYLOAD);
    if (
      policyPayload &&
      policyPayload.payLoad &&
      policyPayload.payLoad.familyStructure
    ) {
      const familyStructure = policyPayload.payLoad.familyStructure;
      if (familyStructure === FamilyStructure.single) {
        plan = 'single';
      } else if (familyStructure === FamilyStructure.couple) {
        plan = 'couple';
      } else {
        plan = 'family';
      }
    }

    if (plan) {
      url += window.location.search ? '&' : '?';
      url += `plan=${plan}`;
    }
  } catch (ex) {
    console.log('get plan fail', ex);
  }

  // Get params from data object and concat as query string
  if (dataObject) {
    try {
      Object.keys(dataObject).forEach(key => {
        url += url.includes('?') ? '&' : '?';
        url += `${key}=${dataObject[key]}`;
      });
    } catch (ex) {
      console.log('parse data fail', ex);
    }
  }

  ReactGA.pageview(url);
};
